/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { IEvidence, EvidencePart, IUser, FieldType, LearningObjective, ProgramData } from "@interfaces/Interfaces";
import { CreateEvidencePart } from "@components/programs/evidenceParts/ComponentWrapper";
import EvidenceTitle from "./EvidenceTitle";
import EvidenceDate from "./EvidenceDate";
import EvidenceBlock from "./EvidenceBlock";
import * as ProgramUtils from "@utils/programUtils";
import * as EvidenceUtils from "@utils/evidenceUtils";
import EvidenceSkillDisplay from "./EvidenceSkillDisplay";

interface EvidencePartsContentProps {
  evidence: IEvidence;
  evidenceJSON: Record<string, any>;
  evidenceParts: EvidencePart[];
  user: IUser;
  program: ProgramData;
  getLearningOutcomesForEvidencePart: () => LearningObjective[];
}

const EvidencePartsContent: React.FC<EvidencePartsContentProps> = ({
  evidence,
  evidenceJSON,
  evidenceParts,
  user,
  program,
  getLearningOutcomesForEvidencePart,
}) => {
  const flattenedEvidenceParts = EvidenceUtils.flattenEvidenceParts(evidenceParts);

  return (
    <>
      <EvidenceTitle title={evidenceJSON.Title ?? evidence.title} />
      <EvidenceDate date={evidence.date} />
      <EvidenceSkillDisplay
        skillID={evidenceJSON.programInfo?.witnessSimulationSkillID}
        program={program}
      />

      {flattenedEvidenceParts.map((item: EvidencePart, index: number) => {
        let dataForPart;
        let mandatoryStandards;
        let optionalStandards;

        if (item["Field type"] === FieldType.NOSSelect) {
          dataForPart = {
            Comps: evidenceJSON.Comps,
            LOs: evidenceJSON.LOs,
          };

          mandatoryStandards = ProgramUtils.getMandatoryStandards(user, program);
          optionalStandards = ProgramUtils.getOptionalStandards(user, program);
        } else if (item["Field type"] === FieldType.SkillsMultiSelect) {
          dataForPart = evidenceJSON.SkillsSelect;
        } else {
          dataForPart = evidenceJSON[item.Name];
        }

        if (dataForPart) {
          return (
            <div
              className="readEvidenceBlock"
              key={`${item.Name}-${index}`}
            >
              {CreateEvidencePart(item["Field type"], {
                definition: item,
                data: dataForPart,
                isDisplay: true,
                evidenceID: evidence.id,
                user: user,
                mandatoryStandards,
                optionalStandards,
                learningOutcomes: getLearningOutcomesForEvidencePart(),
              })}
            </div>
          );
        } else {
          return null;
        }
      })}
      {EvidenceUtils.hideAuditTag(program.ID) ? null : (
        <EvidenceBlock
          header="Included in audit documents"
          textContent={evidence.addToHCPCAudit ? "Yes" : "No"}
          showDivider={false}
        />
      )}
    </>
  );
};

export default EvidencePartsContent;
